import get from 'lodash/get';
import up from 'updeep';
import patch from './patch';
import { getNumericInput } from '../selectors/inputs';

/**
 * Toggle annualized API value as being entered in UI as
 * a montly value.
 * @param {String} apiKey
 * @param {Boolean} value
 */
export default (apiKey, value) => (dispatch, getState) => {
  const ui = { monthlyInputs: (value ? { [apiKey]: true } : up.omit(apiKey)) };
  const state = getState();
  let numericValue = getNumericInput(state, apiKey);
  const isCurrentlyMonthly = get(state.ui, `monthlyInputs.${apiKey}`, false);
  if (!numericValue || Boolean(isCurrentlyMonthly) === Boolean(value)) {
    dispatch(patch({
      ui,
    }));
    return;
  }
  if (value) {
    numericValue /= 12;
  } else {
    numericValue *= 12;
  }
  dispatch(patch({
    ui,
    user_footprint: { inputs: { [apiKey]: numericValue } },
  }));
};
